import { Component, ViewChild, OnInit, ElementRef, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalDataSource } from 'ng2-smart-table';
import { UtilityProvider } from '../../../_helpers/utility';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RestService } from '../../../_services';
import { AlertService, UtilitiesService } from '../../../_services'
import { first } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthenticationService } from '../../../_services/authentication.service'
import { User } from '../../../_models'

import { SurveyRewardService } from '../../../_services/surveyReward.service';


@Component({
  selector: 'ngx-edit-reward',
  templateUrl: './edit-reward.component.html',
  styleUrls: ['./edit-reward.component.scss']
})


export class EditRewardComponent implements OnInit {
  rewardDetails: any;
  rewardForm: FormGroup;
  addData: any;
  loading = false;
  submitted = false;
  success_msg: any;
  processing = false;
  slug: string;
  data: any;
  save_surveyReward: any;
  currentUserSubscription: Subscription;
  currentUser: User;
  rewards: any;

  rewardObject: any;
  @Input() passedData;


  // End the Closeable Alert
  // This is for the self closing alert
  private _message = new Subject<string>();
  staticAlertClosed = false;
  responseMessage: string;
  messageType:any;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private modal: NgbModal,
    private utilityProvider: UtilityProvider,
    private activatedRoute: ActivatedRoute,
    private utilityService: UtilitiesService,  
    private surveyrewardServices: SurveyRewardService, 
    private _surveyRewardService: SurveyRewardService,
    private authenticationService: AuthenticationService,
    private _rest: RestService ) 
    {
      // set up Alert
      setTimeout(() => (this.staticAlertClosed = true), 20000);

      this.slug = this.activatedRoute.snapshot.queryParams.slug;
      // this.surveyrewardServices.rewardDetails$.subscribe(
      //   (details) => {
      //     this.rewardDetails = details;
      //     console.log(details)
      //   }
      // );
 

      this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
        this.currentUser = user;
        console.log('User value', this.currentUser);
      });
  

        // set up Alert
      setTimeout(() => (this.staticAlertClosed = true), 20000);

      this._message.subscribe(message => (this.responseMessage = message));
      this._message.pipe(debounceTime(5000)).subscribe(() => (this.responseMessage = null));


      // this.getUserSurveyReward();

    }


  ngOnInit() {
    console.log(this.passedData);

    this.rewardObject = this.passedData;
    console.log(this.rewardObject)

    this.rewardForm = this.formBuilder.group({
      reward_value: [this.passedData.reward_value, Validators.required],
      reward_type: [this.passedData.reward_type, Validators.required],
      point_to_claim_reward: [this.passedData.point_to_claim_reward, Validators.required],
      reward_quantity: [this.passedData.reward_quantity, Validators.required],
      // reward_image: [this.passedData.reward_image]
    });
  }

  

  inializeForm(){
    this.rewardForm = this.formBuilder.group({
      reward_value: [this.rewardObject.reward_value, Validators.required],
      reward_point: [this.rewardObject.reward_point, Validators.required],
      reward_quant: [this.rewardObject.reward_quant, Validators.required],
      // reward_image: [this.rewardObject.reward_quant, Validators.required],

    });
    console.log(this.rewardObject) 
  }

  getUserSurveyReward() {
    this._surveyRewardService.getUserSurveyReward(this.currentUser.id).pipe(first()).subscribe(data => {
      console.log("data", data);
      if (data['status']) {
        // this.rewardObject = data['data'];
        // this.inializeForm();
        // console.log(this.rewardObject)
      }
    });
  }


  get f() { return this.rewardForm.controls; }
  onFileChange(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.rewardForm.get('reward_image').setValue(file);
    }
  }

  resetForm() {
    this.rewardForm.setValue({
      reward_value: '',
      reward_type: '',
      reward_point: '',
      reward_quant: '',
      image: ''
    });
  }



  onSubmit() {
    // console.log('get here');
    this.submitted = true;
    // stop here if form is invalid
    console.log(this.rewardObject);

    console.log(this.rewardForm.invalid);
    if (this.rewardForm.invalid) {
      return;
    }
    this.loading = true; 
    console.log(this.rewardForm.value);
    const formData = new FormData();
    formData.append('reward_value', this.rewardForm.get('reward_value').value);
    formData.append('reward_type', this.rewardForm.get('reward_type').value);
    formData.append('point_to_claim_reward', this.rewardForm.get('point_to_claim_reward').value);
    formData.append('reward_quantity', this.rewardForm.get('reward_quantity').value);
    // formData.append('reward_image', this.rewardForm.get('reward_image').value);
    this._surveyRewardService.updateSurveyReward(this.rewardObject.id, this.rewardForm.value)
      .pipe(first())
      .subscribe(
        data => {
          console.log('ok>>', data['data']);

          if (data['status']) {
              this.utilityService.showSuccessToast('Updated Reward Successfully')
              this.router.navigate(['/dashboard/rewards/view-all']);
              this.loading = false;

          } else {
            this.success_msg = data['message'];
            this.loading = false; 
          }
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }

  updateReward() {
    this.onSubmit();
  }

 
  closeModal(){
    this.modal.dismissAll()
  }
}
 